import { SystemDescriptions } from "src/common/descriptions";
import dayjs from "dayjs"
import { formatToCurrency, formatToDisplayDate } from "src/common/util";
import { SummaryType } from "src/components/SearchableTable/types";
import { searchableTableUtils } from "src/components/SearchableTable/utils";

const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.SERVICE_CONTRACTS
const commonDescriptions = SystemDescriptions.PAGES.COMMON

export enum ColumnsKeys {
    NO = 'key',
    DESCRIPTION = 'description',
    TOTAL = 'total',
    SERVICE_CATEGORY = 'serviceCategory',
    PAY_DATE = 'payDate',
    NEXT_SERVICE_DEBIT = 'nextServiceDebit',
    IS_ACTIVE = 'isActive',
    ACTIONS = 'ACTIONS',
    IS_MONTHLY = 'isMonthly',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.DESCRIPTION,
        dataIndex: ColumnsKeys.DESCRIPTION,
        key: ColumnsKeys.DESCRIPTION,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.TOTAL,
        dataIndex: ColumnsKeys.TOTAL,
        key: ColumnsKeys.TOTAL,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => formatToCurrency(value)
    },
    {
        title: descriptions.TABLE_COLUMNS.SERVICE_CATEGORY,
        dataIndex: ColumnsKeys.SERVICE_CATEGORY,
        key: ColumnsKeys.SERVICE_CATEGORY,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.IS_MONTHLY,
        dataIndex: ColumnsKeys.IS_MONTHLY,
        key: ColumnsKeys.IS_MONTHLY,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value === 1 ? "Si" : "No"
    },
    {
        title: descriptions.TABLE_COLUMNS.PAY_DATE,
        dataIndex: ColumnsKeys.PAY_DATE,
        key: ColumnsKeys.PAY_DATE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value ?? "NA"
    },
    {
        title: descriptions.TABLE_COLUMNS.NEXT_SERVICE_DEBIT,
        dataIndex: ColumnsKeys.NEXT_SERVICE_DEBIT,
        key: ColumnsKeys.NEXT_SERVICE_DEBIT,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value ? formatToDisplayDate(value) : "NA",
        sorter: (a: any, b: any) => dayjs(b.nextServiceDebit) as any - (dayjs(a.nextServiceDebit) as any),
    },
    {
        title: descriptions.TABLE_COLUMNS.STATUS,
        dataIndex: ColumnsKeys.IS_ACTIVE,
        key: ColumnsKeys.IS_ACTIVE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value === 1 ? commonDescriptions.ACTIVE_STATUS : commonDescriptions.INACTIVE_STATUS
    },
];

export const summaryColumns: Partial<Record<ColumnsKeys, SummaryType>> = {
    [ColumnsKeys.NO]: SummaryType.COUNT,
    [ColumnsKeys.TOTAL]: SummaryType.SUM,
}